import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Button } from "@progress/kendo-react-buttons";


const makeBooleanFilterCellComponent = (allText, trueText, falseText) => {

  return props => {
    const data = props.booleanValues.map(v => v.operator === true
      ? { text: trueText, operator: true }
      : v.operator === false
      ? { text: falseText, operator: false }
      : { text: allText, operator: '' });
    const value = data.find(v => v.operator === props.value);
    const defaultItem = data.find(v => v.operator === '');
    const isDefaultSelected = value === defaultItem;
    const onChange = (event) => {
      if (event.target.value == defaultItem) {
        props.onChange({
          value: '',
          operator: '',
          syntheticEvent: event.syntheticEvent
        });
      } else {
        props.onChange({
          value: event.target.value.operator,
          operator: 'eq',
          syntheticEvent: event.syntheticEvent
        });
      }
    };
    const onClearButtonClick = (event) => {
      event.preventDefault();
      props.onChange({
        value: "",
        operator: "",
        syntheticEvent: event,
      });
    };
    return (
      <div className="k-filtercell">
        <DropDownList
          title={`Filter dropdown for ${props.field} field`}
          data={data} textField="text" dataItemKey="operator"
          onChange={onChange}
          value={value || defaultItem}
          popupSettings={{className:`boolean-filter-options-${props.field}`}}
        />
      <div className="k-filtercell-operator">
        <Button
          className="k-clear-button-visible"
          title="Clear"
          disabled={isDefaultSelected} onClick={onClearButtonClick}
          icon="filter-clear"
        />
      </div>
      </div>
    );
  }
}

export const IsActiveFilterCell = makeBooleanFilterCellComponent("(All)", "Active", "Inactive");

export const IsAdultFilterCell = makeBooleanFilterCellComponent("(All)", "True", "False");

